var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('popper',_vm._g(_vm._b({attrs:{"trigger":_vm.trigger,"force-show":_vm.forceShow,"tagName":_vm.tagName,"options":{
		placement: _vm.placement,
		modifiers: {
			flip: {
				enabled: false,
			},
			preventOverflow: {
				escapeWithReference: true,
			},
		},
	}}},'popper',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"popper"},[(_vm.tooltip)?_c('span',[_vm._v(_vm._s(_vm.tooltip))]):_vm._e(),_vm._t("tooltip")],2),_vm._t("default",null,{"slot":"reference"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }